import React, { useEffect, useState } from 'react'
import {
    Breadcrumb,
    Button, ButtonToolbar,
    Card,
    Col,
    Container,
    Form,
    InputGroup,
    Modal,
    Row, Stack,
    Table, ToggleButton, ToggleButtonGroup
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import Write from 'asset/SvgComponent/Write'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import {
    API_ENDPOINT,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    TEXT, IMAGE_BASE_URL
} from 'utils/globalConstant'
import moment from "moment"
import {Avatar} from "@mui/material";
import View from "asset/SvgComponent/View";
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import {IChangeSchedule} from "../../Attendance/ShiftSwap/types";
import {IEmployees, IPc, IPcPresent, IUserAccount} from "./types";
import {
    IActivity,
    IActivityTime,
    IAttendanceSettings, IEmployee, IPieChartData,
    IScreenshot
} from "../../Attendance/AttendanceReport/Retail/types";
import PieChartWhiteIcon from "asset/SvgComponent/PieChartWhiteIcon";
import PieChartIcon from "asset/SvgComponent/PieChartIcon";
import TableListWhiteIcon from "asset/SvgComponent/TableLIstWhiteIcon";
import TableListIcon from "asset/SvgComponent/TableListIcon";
import ScreenshotIcon from "asset/SvgComponent/ScreenshotIcon";
import PieChart from "components/PieChart";
import Select from "components/ReactSelect";
import {validationSchema2} from "../../Attendance/AttendanceReport/Retail/validationSchema";
import Calendar from "asset/SvgComponent/Calendar";
import PCDetailsPage from "./PCDetails"


export default function Index() {
    const [key, setKey] = useState('team-view')

    const [currentPage, setCurrentPage] = React.useState(0)
    const [lastPage, setLastPage] = React.useState(0)
    const [itemsPerPage, setPerPage] = React.useState(10)
    const [itemsCount, setItemCount] = React.useState(0)
    const [from, setFrom] = React.useState(0)

    const [validation, setValidation] = React.useState('')
    const [error, setError] = React.useState('')
    const [success, setSuccess] = React.useState('')
    const [showError, setShowError] = React.useState(false)
    const [showSuccess, setShowSuccess] = React.useState(false)
    const [showLoading, setShowLoading] = React.useState(false)

    const [dateFormat, setDateFormat] = useState('')

    const [pcs, setPcs] = React.useState<IPcPresent[]>([])
    const [employeesPresent, setEmployeesPresent] = React.useState<IEmployees[]>([])
    const [searchedKeyword, setSearchedKeyword] = React.useState("")
    const [searchedKeyword2, setSearchedKeyword2] = React.useState("")

    const [selectedEmployeeAttendance, setSelectedEmployeeAttendance] = useState(0);
    const [activityTime, setActivityTime] = React.useState<IActivityTime[]>([])
    const [screenshots, setScreenshots] = React.useState<IScreenshot[]>([])
    const [applications, setApplications] = React.useState<string[]>([])
    const [percentage, setPercentage] = React.useState<number[]>([])
    const [sites, setSites] = React.useState<string[]>([])
    const [sitesPercentage, setSitesPercentage] = React.useState<number[]>([])
    const [view, setView] = React.useState("pie-chart")
    const [timeHighlight, setTimeHighlight] = React.useState("")
    const [activityLevel, setActivityLevel] = React.useState("")
    const [modalTitle, setModalTitle] = React.useState("Pie Chart")
    const [attendanceSettings, setAttendanceSettings] = useState<IAttendanceSettings>({
        takeScreenshot: 0,
        noOfScreenshotPerHour: 0,
        allowBlurScreenshot: 0,
        trackMouseKeyboardActivity: 0,
        trackAppUrl: 0,
        autoPause: 0,
        noOfMinutesAutopause: 0
    })
    const [pcOptions, setPCOptions] = useState<{value: number, label: string}[]>([]);
    const [selectedPCOption, setSelectedPCOption] = useState<{value: number, label: string}>({value: 0, label: "All PCs"})
    const [selectedOption, setSelectedOption] = useState<{value: number, label: string}>({value: 0, label: "All Options"})
    const [dateFilter, setDateFilter] = useState(moment().format("YYYY-MM-DD"))
    const [status, setStatus] = useState(0)
    const [filter, setFilter] = useState("status")
    const [currPage, setCurrPage] = useState(0)
    const [selectedPCId, setSelectedPCId] = useState(0)
    const [trackerId, setTrackerId] = useState(0)
    const [options, setOptions] = useState<{value: number, label: string}[]>([
        {value: 0, label: "All Status"},
        {value: 1, label: "Online"},
        {value: 2, label: "Offline"}
    ])
    const [message, setMessage] = useState("")
    const [dots, setDots] = useState('');
    let dotInterval: any = null;

    const [showActivityTime, setShowActivityTime] = React.useState(false)
    const handleShowActivityTime = () => setShowActivityTime(true)
    const handleCloseActivityTime = () => {
        setView("pie-chart")
        setTimeHighlight("")
        setModalTitle("Pie Chart")
        setShowActivityTime(false)
    }

    const handleChangeDropdown = (selectedOptionValue: any) => {
        setSelectedPCOption(selectedOptionValue)
    }

    const handleChangeOptionDropdown = (selectedOptionValue: any) => {
        setSelectedOption(selectedOptionValue)
        setStatus(selectedOptionValue.value)
    }

    const displayPie = (value: number) => {
        // Determine color based on value
        let color = '';
        if (value > 50) {
            color = '#82C341';
        } else if (value > 25) {
            color = '#ff7043';
        } else {
            color = '#DA2B5D';
        }

        return (
            <div className="circular-progress" title={value + "%"}>
                <div
                    className="circle"
                    style={{
                        background: `conic-gradient(${color} ${value * 3.6}deg, #f0f0f0 ${value * 3.6}deg)`
                    }}
                >
                </div>
            </div>
        );
    }

    const getAveragePercentage = () => {
        let averagePercentage = 0;
        activityTime.map(act => {
            averagePercentage += parseInt(act.activity_percentage)
        })

        return `${(averagePercentage/activityTime.length).toFixed(0)}%`
    }

    const handleDisplayActivityLevel = (activity_level: number) => {
        if(activity_level < 50) {
            return <span style={{color: '#DA2B5D',fontSize: '120%'}}>{activity_level} %</span>
        }else if(activity_level < 75){
            return <span style={{color: '#ff7043', fontSize: '120%'}}>{activity_level} %</span>
        }else{
            return <span style={{color: '#82C341', fontSize: '120%'}}>{activity_level} %</span>
        }

    }

    const handleShowApplication = async (e: any, start_time: string, end_time: string) => {

        try {
            const response = await axios.get<IAPI_Response<IPieChartData>>(API_ENDPOINT.GET_ACTIVITY_PER_TIME, {
                params: {
                    employee_attendance_id: selectedEmployeeAttendance,
                    from_time: start_time,
                    to_time: end_time
                },
            })
            const result = await response
            if (result?.data?.results?.applications?.length) {
                setApplications(result?.data?.results?.applications ?? ['Others'])
                setPercentage(result?.data?.results?.percentage ?? [0])
            }else{
                setApplications(['No Activity'])
                setPercentage([0])
            }

            if(result?.data?.results?.sites?.length){
                setSites(result?.data?.results?.sites ?? ['Others'])
                setSitesPercentage(result?.data?.results?.sites_percentage ?? [0])
            }else{
                setSites(['No Activity'])
                setSitesPercentage([0])
            }

            setTimeHighlight(start_time)

            setShowLoading(false)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }

    const handleSearchedKeyword = (e: any) => {
        setSearchedKeyword(e.target.value)
        getPCOpen(dateFilter, e.target.value, status, filter)
    }

    const filterTeamView = (values: any) => {
        getPCOpen(values.date_from, searchedKeyword, values.option, values.filter)
    }

    const getAllAttendanceSettings = async (id: number) => {
        try {
            const res = await axios.get<IAPI_Response<IAttendanceSettings>>(API_ENDPOINT.GET_ATTENDANCE_SETTINGS_BY_EMPLOYEE+"/"+id)
            const result = await res

            if(result.data.results){
                setAttendanceSettings(result.data.results)
            }

        } catch {
            console.log('There is something wrong')
        }
    }

    const handleClickPC = async (id: number) => {
        setCurrPage(1)
        setSelectedPCId(id)
    }

    const handleClickCard = async (id: number) => {
        if(id != 0){
            try {
                const res = await axios.get<IAPI_Response<IActivity>>(API_ENDPOINT.GET_ACTIVITY_TIME, {
                    params: {
                        employee_attendance_id: id
                    },
                })
                const result = await res
                setSelectedEmployeeAttendance(id)
                setActivityTime(result?.data?.results?.activity_time ?? [])

                if(result?.data?.results?.pie_chart_data?.applications && result?.data?.results?.pie_chart_data?.applications.length > 0){
                    setApplications(result?.data?.results?.pie_chart_data?.applications ?? ['Others'])
                    setPercentage(result?.data?.results?.pie_chart_data?.percentage ?? [0])
                }else{
                    setApplications(['No Activity'])
                    setPercentage([0])
                }

                if(result?.data?.results?.pie_chart_data?.sites && result?.data?.results?.pie_chart_data?.sites.length > 0){
                    setSites(result?.data?.results?.pie_chart_data?.sites ?? ['Others'])
                    setSitesPercentage(result?.data?.results?.pie_chart_data?.sites_percentage ?? [0])
                }else{
                    setSites(['No Activity'])
                    setSitesPercentage([0])
                }

                if(result?.data?.results?.screenshots.length && result?.data?.results?.screenshots.length > 0){
                    setScreenshots(result?.data?.results?.screenshots)
                }else{
                    setScreenshots([])
                }

                handleShowActivityTime()

            } catch {
                console.log('There is something wrong')
            }
        }else{
            setActivityTime([])
            setApplications(['No Activity'])
            setPercentage([0])
            setSites(['No Activity'])
            setSitesPercentage([0])
            handleShowActivityTime()
        }
    }

    // const getEmployeesPresent = async (date_from: string, searchedKeyword: string, status: string) => {
    //     setShowLoading(true)
    //     try {
    //         const response = await axios.get<IAPI_Response<IEmployees[]>>(API_ENDPOINT.GET_EMPLOYEES_PRESENT, {
    //             params: {
    //                 searched: searchedKeyword,
    //                 employee_id: selectedPCOption.value,
    //                 date_from: date_from,
    //                 status: status
    //             }
    //         })
    //
    //         const result = await response
    //         if (result?.data?.results?.length) {
    //             setEmployees(result?.data?.results)
    //         }else{
    //             setEmployees([])
    //         }
    //         setShowLoading(false)
    //     } catch {
    //         setShowError(true)
    //         setError(ERROR_MESSAGE.SYSTEM_ERROR)
    //     }
    //
    //     setTimeout(() => {
    //         setShowError(false)
    //     }, 3000);
    // }

    const getPCOpen = async (date_from: string, searchedKeyword: string, option: number, filterStatus: string) => {
        setShowLoading(true)
        setMessage("Please wait while loading the PCs")
        try {
            const response = await axios.get<IAPI_Response<IPcPresent[]>>(API_ENDPOINT.GET_PC_OPEN, {
                params: {
                    searched: searchedKeyword,
                    pc_id: selectedPCOption.value,
                    date_from: date_from,
                    option: option,
                    filter: filterStatus
                }
            })

            const result = await response

            if (result?.data?.results?.length) {
                setPcs(result?.data?.results)
                setMessage("")
            }else{
                setPcs([])
                setMessage("No Data Available.")
            }
            setShowLoading(false)
            clearInterval(dotInterval)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }

    const getEmployeesCurrentlyPresent = async (searchedKeyword: string) => {
        setShowLoading(true)
        try {
            const response = await axios.get<IAPI_Response<IEmployees[]>>(API_ENDPOINT.GET_EMPLOYEES_CURRENT_PRESENT, {
                params: {
                    searched: searchedKeyword
                }
            })

            const result = await response
            if (result?.data?.results?.length) {
                setEmployeesPresent(result?.data?.results)
            }else{
                setEmployeesPresent([])
            }
            setShowLoading(false)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }

    const getAllUserAccounts = async () => {
        try {
            const res = await axios.get<IAPI_Response<IUserAccount[]>>(API_ENDPOINT.GET_ALL_USER_ACCOUNTS)
            const result = await res
            if (result?.data?.results?.length) {
                const user_accounts = result?.data?.results;
                setOptions([])

                setOptions(current => [...current, {value: 0, label: "All Users"}]);
                user_accounts.map(user => {
                    setOptions(current => [...current, {value: user.id, label: user.username}]);
                })


            }
        } catch {
            console.log('There is something wrong')
        }
    }

    const getAllPCs = async () => {
        try {
            const res = await axios.get<IAPI_Response<IPc[]>>(API_ENDPOINT.GET_ALL_PCS)
            const result = await res
            if (result?.data?.results?.length) {
                const pcs = result?.data?.results;
                setPCOptions([])

                setPCOptions(current => [...current, {value: 0, label: "All PCs"}]);
                pcs.map(employee => {
                    setPCOptions(current => [...current, {value: employee.id, label: employee.pc_name}]);
                })


            }
        } catch {
            console.log('There is something wrong')
        }
    }

    useEffect(() => {
        setDateFormat(localStorage.getItem('date_format') ?? "")
        const fetchEmployees = () => {
            // getEmployeesPresent(dateFilter, searchedKeyword, status)
            getEmployeesCurrentlyPresent(searchedKeyword2)
            getPCOpen(dateFilter, searchedKeyword, status, filter)
            getAllPCs()
        }
        fetchEmployees() // Call immediately on mount

        const interval = setInterval(fetchEmployees, 60000) // Run every 60 seconds

        return () => clearInterval(interval) // Cleanup on unmount
    }, [dateFilter, searchedKeyword, searchedKeyword2, status, selectedPCId, filter])

    useEffect(() => {
        dotInterval = setInterval(() => {
            setDots(prevDots => {
                if (prevDots.length >= 3) {
                    return '';
                }
                return prevDots + '.';
            });
        }, 500);

        return () => clearInterval(dotInterval);
    }, []);

    return (
        <>
            <Container fluid>
                <h5 className='fw-bold'>Activity Tracking</h5>
                <Breadcrumb className='breadcrumbs'>
                    <Breadcrumb.Item className=' text-decoration-none' href='/home'>
                        Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Monitoring
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Activity Tracking</Breadcrumb.Item>
                </Breadcrumb>

                <Alert
                    type="success"
                    show={showSuccess}
                    message={success}
                    setShow={() => {
                        setShowSuccess(false);
                    }
                    }
                />

                <Alert
                    type="error"
                    show={showError}
                    message={error}
                    setShow={() => {
                        setShowError(false);
                    }
                    }
                />


                        <Tabs
                            variant={'tabs'}
                            className='tabs '
                            id='controlled-tab-example'
                            activeKey={key}
                            onSelect={(k: any) => {
                                setKey(k)
                            }}
                            // sx={{
                            //   opacity: open ? 1 : 0,
                            //   fontWeight: openDropdown === 0 ? 700 : 100,
                            // }}
                        >
                            <Tab  eventKey='team-view' title='Team View'>
                                {
                                    selectedPCId == 0 ?
                                        <Card className='border-0  p-0 bordered-card-tabs'>
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={12}>
                                                        <Formik
                                                            initialValues={
                                                                {
                                                                    employee_id: '',
                                                                    date_from: dateFilter == "" ?new Date().toISOString().split("T")[0] : dateFilter,
                                                                    filter: '',
                                                                    option: 0
                                                                }
                                                            }
                                                            validationSchema={validationSchema2}
                                                            onSubmit={filterTeamView}
                                                        >
                                                            {({
                                                                  values,
                                                                  errors,
                                                                  touched,
                                                                  handleChange,
                                                                  handleBlur,
                                                                  handleSubmit,
                                                                  isSubmitting
                                                              }) => (
                                                                <Form noValidate onSubmit={handleSubmit}>
                                                                    <Row>
                                                                        <Col sm={2}>
                                                                            <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                                <Form.Label className='fw-bold form-labels'>PC Name</Form.Label>
                                                                                <Select
                                                                                    name="pc_name"
                                                                                    value={selectedPCOption}
                                                                                    options={pcOptions}
                                                                                    onChange={(e: any) => {
                                                                                        handleChangeDropdown(e)
                                                                                        handleSubmit()
                                                                                    }}
                                                                                />
                                                                                <Form.Control.Feedback type="invalid">
                                                                                    {errors.employee_id}
                                                                                </Form.Control.Feedback>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={2}>
                                                                            <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                                <Form.Label className='fw-bold form-labels'>Date</Form.Label>
                                                                                <InputGroup className='mb-2 ' size={'sm'}>
                                                                                    <InputGroup.Text id='basic-addon1' className='text-muted fw-bold bg-white'>
                                                                                        <Calendar/>
                                                                                    </InputGroup.Text>
                                                                                    <Form.Control
                                                                                        size={'sm'}
                                                                                        type='date'
                                                                                        placeholder='Friday, June 03, 2022'
                                                                                        name='date_from'
                                                                                        value={values.date_from}
                                                                                        onChange={(e: any) => {
                                                                                            handleChange(e);
                                                                                            handleSubmit();
                                                                                            setDateFilter(e.target.value)
                                                                                        }}
                                                                                        onBlur={handleBlur}
                                                                                        isInvalid={touched.date_from && !!errors.date_from}
                                                                                        // max={moment().format("YYYY-MM-DD")}
                                                                                    />
                                                                                    <Form.Control.Feedback type="invalid">
                                                                                        {errors.date_from}
                                                                                    </Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={2}>
                                                                            <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                                <Form.Label className='fw-bold form-labels'>Filter By</Form.Label>
                                                                                <Form.Select
                                                                                    size={'sm'}
                                                                                    name="filter"
                                                                                    value={values.filter}
                                                                                    onChange={async (e: any) => {
                                                                                        handleChange(e);
                                                                                        setFilter(e.target.value)
                                                                                        if(e.target.value == "status"){
                                                                                            setOptions([
                                                                                                {value: 0, label: "All Status"},
                                                                                                {value: 1, label: "Online"},
                                                                                                {value: 2, label: "Offline"}
                                                                                            ])
                                                                                            values.option = 0;
                                                                                        }else if(e.target.value == "pc_name"){
                                                                                            setOptions([
                                                                                                {value: 0, label: "A-Z"},
                                                                                                {value: 1, label: "Z-A"}
                                                                                            ])
                                                                                            values.option = 0;
                                                                                        }else if(e.target.value == "user"){
                                                                                            await getAllUserAccounts()
                                                                                        }
                                                                                        setStatus(0)
                                                                                        handleSubmit();
                                                                                    }}
                                                                                    onBlur={handleBlur}
                                                                                    isInvalid={touched.filter && !!errors.filter}
                                                                                >
                                                                                    <option value="status">Status</option>
                                                                                    <option value="user">User Account</option>
                                                                                    <option value="pc_name">PC Name</option>

                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={2}>
                                                                            <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                                <Form.Label className='fw-bold form-labels'>Options</Form.Label>
                                                                                <Select
                                                                                    name="option"
                                                                                    value={selectedOption}
                                                                                    options={options}
                                                                                    onChange={(e: any) => {
                                                                                        // setStatus(e.target.value.value)
                                                                                        handleChangeOptionDropdown(e)
                                                                                        handleChange(e)
                                                                                        handleSubmit()
                                                                                    }}
                                                                                />
                                                                                {/*<Form.Select*/}
                                                                                {/*    size={'sm'}*/}
                                                                                {/*    name="option"*/}
                                                                                {/*    value={values.option}*/}
                                                                                {/*    onChange={(e: any) => {*/}
                                                                                {/*        handleChange(e);*/}
                                                                                {/*        handleSubmit();*/}
                                                                                {/*        setStatus(e.target.value)*/}
                                                                                {/*    }}*/}
                                                                                {/*    onBlur={handleBlur}*/}
                                                                                {/*    isInvalid={touched.option && !!errors.option}*/}
                                                                                {/*>*/}
                                                                                {/*    {*/}
                                                                                {/*        options.map((option, index) => (*/}
                                                                                {/*            <option key={index} value={option.value}>{option.label}</option>*/}
                                                                                {/*        ))*/}
                                                                                {/*    }*/}


                                                                                {/*</Form.Select>*/}
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className='d-flex justify-content-end hidden' style={{height: '30px', margin: 'auto 0 auto 0'}}>
                                                                            <InputGroup size='sm' className={'w-50'}>
                                                                                <Form.Control
                                                                                    aria-label='search'
                                                                                    aria-describedby='inputGroup-sizing-sm'
                                                                                    placeholder='Search...'
                                                                                    value={searchedKeyword}
                                                                                    onChange={handleSearchedKeyword}
                                                                                />
                                                                                <InputGroup.Text className='bg-transparent search-input '>
                                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                                </InputGroup.Text>
                                                                            </InputGroup>
                                                                        </Col>
                                                                    </Row>

                                                                </Form>
                                                            )}
                                                        </Formik>
                                                    </Col>




                                                </Row>
                                                <Row>
                                                    {
                                                        pcs.length > 0 ?
                                                            pcs.map((pc, index) => (
                                                                <Col key={index} sm={3} className={"mb-4"}>
                                                                    <Card className='shadow bordered-card border-0 card-employee'
                                                                          onClick={() => {
                                                                              // getAllAttendanceSettings(employee.employee_id)
                                                                              handleClickPC(pc.machine_id)
                                                                              setTrackerId(pc.id)
                                                                          }}
                                                                    >
                                                                        <Card.Body style={{ padding: 0 }}>
                                                                            <Container fluid className='p-2'>

                                                                                <Row style={{fontSize: '85%'}}>
                                                                                    <Col sm={10} className='fw-bold'>
                                                                                        <Stack direction='horizontal'>
                                                                                            <div className='d-flex align-items-center'>
                                                                                                <div
                                                                                                    title={!pc.is_online ? "Offline" : "Online"}
                                                                                                    className={`status-indicator me-2 ${!pc.is_online ? "offline" : "online"}`}
                                                                                                ></div>
                                                                                                <span>{pc.pc_name}</span>
                                                                                            </div>

                                                                                        </Stack>
                                                                                    </Col>
                                                                                    {/*<Col sm={2} className="d-flex align-items-center justify-content-center">*/}
                                                                                    {/*    */}
                                                                                    {/*</Col>*/}
                                                                                </Row>

                                                                                <Row className={'text-center'} style={{fontSize: '75%'}}>
                                                                                    <Col sm={12}>
                                                                                        <span className={"fw-bold"}>{pc.username}</span>
                                                                                        <br />
                                                                                        <span style={{fontSize: '90%'}} className='text-muted fw-light'>Current User</span>
                                                                                        {/*<br/>*/}
                                                                                        {/*<span className='text-muted fw-light'>{moment(new Date(pc.track_in)).format(localStorage.getItem('date_format') ?? "")} </span>*/}
                                                                                        {/*{*/}
                                                                                        {/*    pc.track_out ?*/}
                                                                                        {/*        <span style={{fontSize: '90%'}} className='text-muted fw-light'>{moment(pc.track_in).format(localStorage.getItem('time_format') ?? "")} - {moment(pc.track_out).format(localStorage.getItem('time_format') ?? "")}</span>*/}
                                                                                        {/*        : <span style={{fontSize: '90%'}} className='text-muted fw-light'>{moment(pc.track_in).format(localStorage.getItem('time_format') ?? "")} - On going</span>*/}
                                                                                        {/*}*/}

                                                                                    </Col>
                                                                                </Row>
                                                                                <hr style={{marginTop: '3px', marginBottom: '3px'}}/>
                                                                                {/* Orange Productivity Percentage */}
                                                                                <Row className='text-center' style={{ fontSize: '75%' }}>
                                                                                    <Col sm={12} style={{ position: 'relative' }}>
                                                                                        <div style={{
                                                                                            position: 'relative',
                                                                                            width: '100%',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        }}>
                                                                                            {/* Background Bar (Starts from Left) */}
                                                                                            <div style={{
                                                                                                backgroundColor: '#FFA500', // Orange color
                                                                                                height: '40px', // Adjust as needed
                                                                                                borderRadius: '5px',
                                                                                                width: pc.productivity + '%',
                                                                                                minWidth: '10px',
                                                                                                transition: 'width 0.3s ease-in-out',
                                                                                                position: 'absolute',
                                                                                                left: '0'
                                                                                            }}></div>

                                                                                            {/* Centered Text */}
                                                                                            <div style={{
                                                                                                position: 'relative',
                                                                                                width: '100%',
                                                                                                textAlign: 'center',
                                                                                                fontSize: '24px',
                                                                                                fontWeight: 'bold',
                                                                                                color: 'black',
                                                                                                zIndex: '2', // Ensure text stays above background
                                                                                            }}>
                                                                                                {pc.productivity}%
                                                                                            </div>
                                                                                        </div>
                                                                                        <span className="text-muted fw-light">Productivity</span>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row className='text-center' style={{ fontSize: '75%' }}>
                                                                                    <Col className='fw-bold display-ellipsis' sm={12} title={"Recent Viewed Application"}>
                                                                                        {pc.total_time_hours} hrs.
                                                                                        <br />
                                                                                        <span style={{fontSize: '90%'}} className='text-muted fw-light'>Total Time Online</span>
                                                                                    </Col>
                                                                                </Row>
                                                                                <hr style={{marginTop: '3px', marginBottom: '3px'}}/>
                                                                                {/*<Row className={'text-center'} style={{fontSize: '75%'}}>*/}
                                                                                {/*    <Col className='fw-bold display-ellipsis' sm={12} title={"Recent Viewed Application"}>*/}
                                                                                {/*        {pc.recent_viewed_app}*/}
                                                                                {/*        <br />*/}
                                                                                {/*        <span style={{fontSize: '90%'}} className='text-muted fw-light'>Recent Application</span>*/}
                                                                                {/*    </Col>*/}
                                                                                {/*</Row>*/}
                                                                                {/*<hr style={{marginTop: '3px', marginBottom: '3px'}}/>*/}
                                                                                {/*<Row className={'text-center'} style={{fontSize: '75%'}}>*/}
                                                                                {/*    <Col className='fw-bold' sm={12}>*/}
                                                                                {/*        {employee.hours_worked} hrs.*/}
                                                                                {/*        <br />*/}
                                                                                {/*        <span style={{fontSize: '90%'}} className='text-muted fw-light'>Hours Worked Including Passive</span>*/}
                                                                                {/*    </Col>*/}
                                                                                {/*</Row>*/}

                                                                                <Row className={'text-center'} style={{fontSize: '75%'}}>
                                                                                    <Col className='fw-bold display-ellipsis' sm={12} title={"Top Application Visited"}>
                                                                                        {pc.top_application_visited}
                                                                                        <br />
                                                                                        <span style={{fontSize: '90%'}} className='text-muted fw-light'>Top Application Visited</span>
                                                                                    </Col>
                                                                                </Row>
                                                                                {/*<hr style={{marginTop: '3px', marginBottom: '3px'}}/>*/}
                                                                                {/*<Row >*/}
                                                                                {/*    <Col sm={12} className='fw-bold text-center'>*/}
                                                                                {/*        {*/}
                                                                                {/*            handleDisplayActivityLevel(employee.activity_level)*/}
                                                                                {/*        }*/}
                                                                                {/*        <br />*/}
                                                                                {/*        <span style={{fontSize: '70%'}} className='text-muted fw-light'>Productivity</span>*/}
                                                                                {/*    </Col>*/}
                                                                                {/*</Row>*/}

                                                                                {/*</Table>*/}
                                                                            </Container>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                            ))
                                                            : <Col sm={12} className={'text-center'}>{message} <span className="inline-block w-12 text-left">{dots}</span></Col>
                                                    }

                                                </Row>
                                                <br/>
                                            </Card.Body>
                                        </Card> :
                                        <PCDetailsPage pcId={selectedPCId} date_selected={dateFilter} trackerId={0} onBack={() => setSelectedPCId(0)} />
                                }

                            </Tab>
                            {/*<Tab eventKey='screen-view' title='Screen View'>*/}
                            {/*    <Card className='border-0  p-0 bordered-card-tabs'>*/}
                            {/*        <Card.Body>*/}
                            {/*            <Row>*/}
                            {/*                {*/}
                            {/*                    employeesPresent.length > 0 ?*/}
                            {/*                        employeesPresent.map((employee, index) => (*/}
                            {/*                            <Form.Group key={index} as={Col} md="3" style={{padding:"10px"}}>*/}
                            {/*                                <a href={IMAGE_BASE_URL + employee.screenshot} target="_blank" className="photo-a" rel="noreferrer">*/}
                            {/*                                    <div className="card" >*/}
                            {/*                                        <img style={{height: "200px", width: "auto", objectFit: "cover"}} className="card-img-top" alt={"Captured Image"} src={IMAGE_BASE_URL + employee.screenshot}/>*/}
                            {/*                                        <div className="card-body d-flex flex-column" style={{ paddingTop: '3px', paddingBottom: '3px', paddingLeft: '5px'}}>*/}
                            {/*                                            <Row>*/}
                            {/*                                                <Col sm={10} title={"Title"}>*/}
                            {/*                                                    <p className="card-text display-title" style={{color:"black"}}>*/}
                            {/*                                                        <b style={{fontSize: '80%'}}>{employee.first_name} {employee.last_name}</b>*/}
                            {/*                                                        <br/>*/}
                            {/*                                                        <span style={{fontSize: '70%'}}>Time in: {moment(employee.in_time).format(localStorage.getItem('time_format') ?? "")}</span>*/}
                            {/*                                                    </p>*/}
                            {/*                                                </Col>*/}


                            {/*                                            </Row>*/}

                            {/*                                        </div>*/}

                            {/*                                    </div>*/}
                            {/*                                </a>*/}
                            {/*                            </Form.Group>*/}
                            {/*                        ))*/}

                            {/*                        :*/}
                            {/*                        <Form.Group as={Col} md="12" style={{padding:"10px"}}>*/}
                            {/*                            <p className={'text-center'}>There are no employees who are present.</p>*/}
                            {/*                        </Form.Group>*/}
                            {/*                }*/}

                            {/*            </Row>*/}
                            {/*        </Card.Body>*/}
                            {/*    </Card>*/}
                            {/*</Tab>*/}
                        </Tabs>

                        {/*<Loader show={showLoading} />*/}


                {/* ACTIVITY TIME MODAL*/}
                <Modal className='modal' size="lg" centered show={showActivityTime} onHide={handleCloseActivityTime}>
                    <Modal.Header closeButton >
                        <Modal.Title className='fw-bold text-center'>Activity Time and Screenshots</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={4}></Col>
                            <Col sm={4} className={'text-center'}>
                                <p className={'fw-bold'}>{modalTitle}</p>
                            </Col>
                            <Col sm={4}>
                                <div className={'d-flex justify-content-end'}>
                                    <ButtonToolbar>

                                        <ToggleButtonGroup
                                            className="switch-view"
                                            type="radio"
                                            name="option-views"
                                            value={"default"}
                                            // onChange={(selected: any) => setView(selected)}
                                        >
                                            <ToggleButton onClick={() => {
                                                setView("pie-chart")
                                                setModalTitle("Pie Chart")
                                            }} title={"Pie Chart"} style={{backgroundColor: view == "pie-chart" ? '#ff7043' : 'white'}}  value={"pie-chart"}>{view == "pie-chart" ? <PieChartWhiteIcon/> : <PieChartIcon/>}</ToggleButton>
                                            <ToggleButton onClick={() => {
                                                setView("list-chart")
                                                setModalTitle("List Chart")
                                            }} title={"List Chart"} style={{backgroundColor: view == "list-chart" ? '#ff7043' : 'white'}}  value={"list-chart"}>{view == "list-chart" ? <TableListWhiteIcon/> : <TableListIcon/>}</ToggleButton>
                                            <ToggleButton onClick={() => {
                                                setView("screenshot")
                                                setModalTitle("Screenshots")
                                            }} title={"Screenshot"} style={{backgroundColor: view == "screenshot" ? '#ff7043' : 'white'}}  value={"screenshot"}>{view == "screenshot" ? <ScreenshotIcon color={"white"}/> : <ScreenshotIcon color={"#a7a9ac"}/>}</ToggleButton>
                                        </ToggleButtonGroup>
                                    </ButtonToolbar>
                                </div>
                            </Col>
                        </Row>
                        {
                            view == "screenshot" ?
                                <Row>
                                    {
                                        attendanceSettings.takeScreenshot == 1 ?
                                            screenshots.length > 0 ?
                                                screenshots.map((screenshot, index) => (
                                                    <Form.Group as={Col} key={index} md="3" style={{padding:"10px"}}>
                                                        <a href={IMAGE_BASE_URL + screenshot.path} target="_blank" className="photo-a" rel="noreferrer">
                                                            <div className="card" >
                                                                <div className="card-body d-flex flex-column" style={{ paddingTop: '3px', paddingBottom: '3px', paddingLeft: '5px'}}>
                                                                    <Row>
                                                                        <Col sm={10} title={screenshot.title}>
                                                                            <p className="card-text display-title" style={{color:"black"}}><span style={{fontSize: '70%'}}>{screenshot.created_at ? moment(screenshot.created_at).format(localStorage.getItem('time_format') ?? "") : ""}</span> &nbsp;&nbsp;&nbsp;<b style={{fontSize: '80%'}}>{screenshot.title}</b></p>
                                                                        </Col>
                                                                        {
                                                                            attendanceSettings.trackMouseKeyboardActivity == 1 ?
                                                                                <Col sm={2} style={{margin: 'auto'}}>{displayPie(screenshot.percentage)}</Col>
                                                                                : ""
                                                                        }

                                                                    </Row>

                                                                </div>
                                                                <img style={{height: "130px", width: "auto", objectFit: "cover"}} className="card-img-top" alt={"Captured Image"} src={IMAGE_BASE_URL + screenshot.path}/>
                                                            </div>
                                                        </a>
                                                    </Form.Group>

                                                ))

                                                : <p className={'text-center'}>No Screenshot yet.</p>
                                            : <p className={'text-center'}>Screenshot is disabled for the employee.</p>
                                    }
                                </Row>
                                :
                                <Row>
                                    <Col sm={4}>
                                        {
                                            attendanceSettings.trackMouseKeyboardActivity == 1 ?
                                                <>
                                                    <Table responsive size='sm'>
                                                        <thead >
                                                        <tr>
                                                            <th className='text-center' style={{width: '70%'}}>Time</th>
                                                            <th className='text-center' style={{width: '30%'}}>Activity</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            activityTime.length > 0 ?
                                                                <>
                                                                    {
                                                                        activityTime.map((act, index) => (
                                                                            <tr key={index}>
                                                                                <td className={'text-center'} onClick={(e: any) => {
                                                                                    handleShowApplication(e, act.start_time, act.end_time)
                                                                                    setActivityLevel(`${act.activity_percentage} %`)
                                                                                }}>
                                                                                    <span className={timeHighlight == act.start_time ? 'highlight-time-display' : 'time-display'}>{moment(act.start_time).format(localStorage.getItem('time_format') ?? "hh:mm:ss A") +' - '+ moment(act.end_time).format(localStorage.getItem('time_format') ?? "hh:mm:ss A")}</span>
                                                                                </td>
                                                                                <td onClick={(e: any) => {
                                                                                    handleShowApplication(e, act.start_time, act.end_time)
                                                                                    setActivityLevel(`${act.activity_percentage} %`)
                                                                                }} className='text-center'>
                                                                                    <span className={timeHighlight == act.start_time ? 'highlight-time-display' : 'time-display'}>{act.activity_percentage} %</span>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                    <tr>
                                                                        <td onClick={() => {
                                                                            setTimeHighlight("average")
                                                                            handleClickCard(selectedEmployeeAttendance)
                                                                            setActivityLevel(getAveragePercentage())
                                                                        }} className={'text-center fw-bold'}>
                                                                            <span className={timeHighlight == "average" ? 'highlight-time-display' : 'time-display'}>Average</span>
                                                                        </td>
                                                                        <td onClick={() => {
                                                                            setTimeHighlight("average")
                                                                            handleClickCard(selectedEmployeeAttendance)
                                                                            setActivityLevel(getAveragePercentage())
                                                                        }} className={'text-center fw-bold'}>
                                                                            <span className={timeHighlight == "average" ? 'highlight-time-display' : 'time-display'}>{getAveragePercentage()}</span>
                                                                        </td>
                                                                    </tr>
                                                                </>

                                                                : <tr>
                                                                    <td className='text-center' colSpan={2}>No Attendance Activity.</td>
                                                                </tr>
                                                        }

                                                        </tbody>
                                                    </Table>
                                                    <p style={{fontSize: '80%'}}>Note: Click a specific time to view the apps and urls for that time frame.</p>
                                                </>
                                                : <p className={'text-center'}>Tracking of activity level is disabled for the employee.</p>
                                        }

                                    </Col>
                                    <Col sm={8}>
                                        <h6 className={'text-center fw-bold'}>Apps</h6>
                                        {
                                            attendanceSettings.trackAppUrl == 1 ?
                                                view == "pie-chart" ?
                                                    <PieChart applications={applications} percentage={percentage} activityLevel={activityLevel == "" ? getAveragePercentage() : activityLevel}/> :
                                                    <Table responsive size='sm'>
                                                        <thead >
                                                        <tr>
                                                            <th className='text-center' style={{width: '10%'}}></th>
                                                            <th className='text-center' style={{width: '65%'}}>Application</th>
                                                            <th className='text-center' style={{width: '35%'}}>Percentage</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            applications.length > 0 ?
                                                                <>
                                                                    {
                                                                        applications.map((app, index) => (
                                                                            <tr key={index}>
                                                                                <td className='text-left'>{index + 1}</td>
                                                                                <td className='text-left'>{app}</td>
                                                                                <td className='text-center'>{percentage[index]} %</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </>

                                                                : <tr>
                                                                    <td className='text-center' colSpan={3}>No Activity.</td>
                                                                </tr>
                                                        }

                                                        </tbody>
                                                    </Table>
                                                : <p className={'text-center'}>Tracking of app and url is disabled for the employee</p>
                                        }

                                        <h6 className={'mt-2 text-center fw-bold'}>URLs</h6>
                                        {
                                            attendanceSettings.trackAppUrl == 1 ?
                                                view == "pie-chart" ?
                                                    <PieChart applications={sites} percentage={sitesPercentage} activityLevel={activityLevel == "" ? getAveragePercentage() : activityLevel}/> :
                                                    <Table responsive size='sm'>
                                                        <thead >
                                                        <tr>
                                                            <th className='text-center' style={{width: '10%'}}></th>
                                                            <th className='text-center' style={{width: '65%'}}>Site</th>
                                                            <th className='text-center' style={{width: '25%'}}>Percentage</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            sites.length > 0 ?
                                                                <>
                                                                    {
                                                                        sites.map((site, index) => (
                                                                            <tr key={index}>
                                                                                <td className='text-left'>{index + 1}</td>
                                                                                <td className='text-left'>{site}</td>
                                                                                <td className='text-center'>{sitesPercentage[index]} %</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </>

                                                                : <tr>
                                                                    <td className='text-center' colSpan={3}>No Activity.</td>
                                                                </tr>
                                                        }

                                                        </tbody>
                                                    </Table>
                                                : <p className={'text-center'}>Tracking of app and url is disabled for the employee</p>
                                        }

                                    </Col>
                                </Row>
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={handleCloseActivityTime}
                            variant='primary text-white'
                            size={'sm'}
                            className='mx-2'
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </>
    )
}
